import { useMemo, useRef, useState } from "react";
import parse from "html-react-parser";
import ContentTerm from "layout/discovery/content/ContentTerm";

const SHOW_DELAY = 250;
const HIDE_DELAY = 200;

const isTooltip = (element) => {
  const { classList } = element;
  return classList.contains("tooltip") || classList.contains("tooltip-inner");
};

export const useDelayedHover = ({ onMouseOver, onMouseOut }) => {
  const [hovered, setHovered] = useState(false);
  const showTimeout = useRef();
  const hideTimeout = useRef();

  const handleMouseOver = (e) => {
    if (isTooltip(e.target)) return;

    onMouseOver();

    clearTimeout(hideTimeout.current);

    showTimeout.current = setTimeout(() => {
      setHovered(true);
    }, SHOW_DELAY);
  };

  const handleMouseOut = () => {
    onMouseOut();

    clearTimeout(showTimeout.current);

    hideTimeout.current = setTimeout(() => {
      setHovered(false);
    }, HIDE_DELAY);
  };

  return { hovered, handleMouseOver, handleMouseOut };
};

/* Hook takes string which contains span elements and replaces them with ContentTerm react components */
export const useContent = (text, boldContentTerms) => {
  const content = useMemo(() => {
    const spanOpenTag = `<span style='color: #000000;background-color: #FCEFC7;border-bottom: 2px solid #FCEFC7;' qtip="">`;
    const spanCloseTag = `</span>`;

    let splittedText = text.split(
      new RegExp(`(${spanOpenTag}|${spanCloseTag})`)
    );

    splittedText = splittedText.filter((item) => item !== "");

    const result = [];
    let i = 0;
    while (i < splittedText.length) {
      if (
        splittedText[i] === spanOpenTag &&
        splittedText[i + 2] === spanCloseTag
      ) {
        result.push(
          <ContentTerm legend={splittedText[i + 1]} bold={boldContentTerms} />
        );
        i = i + 3;
        continue;
      }

      result.push(parse(splittedText[i]));
      i = i + 1;
    }

    return result;
  }, [text]);

  return content;
};
